var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:{ 'btn-cancel': !!_vm.cancel },attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('clickEvent')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }